
import axios from '../node_modules/axios/dist/axios';

export const _errorReporting = (error) => {
	console.error(error);
	//alert('An error has occured');
}

export const _setHeaders = () => {
	if( window.csrfToken ) {
		axios.defaults.headers.common['X-CSRF-Token'] = window.csrfToken;
	}
}

_setHeaders();

export const getOffers = async () => {
	if(! offers_url ) {
		throw new Error('Undefined variable: offers_url');
	}
	
	try {
		const response = await axios.get( offers_url );
		return response.data;
	} catch (error) {
		_errorReporting(error);
	}
};



export const addToCart = async (data) => {
	if(! add2cart_url ) {
		throw new Error('Undefined variable: add2cart_url');
	}
	
	let headers = {};
	const token = data.get('_csrfToken');
	if( token ) {
		headers = { 'X-CSRF-Token': token }
	}
	
	try {
		const response = await axios.post( add2cart_url, data, headers);
		return response.data;
	} catch (error) {
		_errorReporting(error);
	}
};